// @ts-check
import { Splide } from '@splidejs/splide';
import { wrap } from '../utils/wrappers';

export class SplideSlider {
    /** @type {HTMLElement} */
    root;

    /**
     * @param {HTMLElement} list
     * @param {import('@splidejs/splide').Options} options
     */
    constructor(list, options = {}) {
        this.list = list;
        this.options = options;

        this.#init();
    }

    #init() {
        const root = this.list.closest('.splide');

        if (root instanceof HTMLElement) {
            // If the root splide element already exists, use it.
            this.root = root;
        } else {
            // Otherwise, create a new root and track element.
            this.#createWrapper();
        }
    }

    #createWrapper() {
        const html = '<div class="splide"><div class="splide__track">';
        const wrapper = wrap(this.list, html);

        this.root = wrapper;
    }

    /**
     * @param {Element} track
     * @param {string} id
     */
    #addArrows(track, id) {
        const html = `
            <div class="splide__arrows">
                <button ${id ? 'id="' + id + '-prev" ' : ''}class="splide__arrow splide__arrow--prev"></button>
                <button ${id ? 'id="' + id + '-next" ' : ''}class="splide__arrow splide__arrow--next"></button>
            </div>
        `;

        track.insertAdjacentHTML('beforebegin', html);
    }

    #addClasses() {
        // Add root class
        // this.root.classList.add('splide');

        // Add track and list classes
        // this.root.firstElementChild?.classList.add('splide__track');
        // this.list.classList.add('splide__list');

        // Add arrows if not disabled
        // if (this.options.arrows !== false && this.root.firstElementChild) {
        //     this.#addArrows(this.root.firstElementChild, this.list.id);
        // }

        // Add slide classes to all children
        const children = this.list.children ?? [];
        [...children].forEach((slide) => slide.classList.add('splide__slide'));
    }

    enableAutoPlay() {
        this.options.autoplay = true;

        if (!this.options.interval) {
            this.options.interval = 5000;
        }

        return this;
    }

    disablePagination() {
        this.options.pagination = false;
        this.options.arrows = false;

        if (this.options.breakpoints) {
            for (const [, value] of Object.entries(this.options.breakpoints)) {
                value.pagination = false;
                value.arrows = false;
            }
        }

        return this;
    }

    mount(...args) {
        this.#addClasses();

        const splide = new Splide(this.root, this.options);

        return splide.mount(...args);
    }
}
